import { EnvelopeIcon } from "@heroicons/react/24/solid"
import Button from "~/components/ui/Button"

import Modal from "~/components/ui/Modal"
import ReservationInvoiceWrapper from "~/components/helpers/ReservationInvoiceWrapper"
import EditInvoice from "~/components/Admin/Invoices/EditInvoice"
import { useEditInvoiceButton } from "./useEditInvoiceButton"
import ICamper from "~/interfaces/ICamper"
import { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"

interface Props {
  setIsSlideoverOpen: (v: boolean) => void
  disabled?: boolean
  camper: ICamper
}

export const EditInvoiceButton = ({ setIsSlideoverOpen, disabled = false, camper }: Props) => {
  const { selectedReservation, canOpenModal, setOpenModal, campingStyle } = useEditInvoiceButton()
  const { setSelectedCamperId } = useContext(AdminContext)
  return (
    <>
      <Button
        variant="white"
        size="small"
        shadow="small"
        className="flex items-center text-gray-600"
        type="button"
        onClick={() => {
          if (!disabled) {
            setOpenModal(true)
            setSelectedCamperId(camper?.id)
          }
        }}
        disabled={disabled}
        dataTestId="edit-invoice-button"
      >
        <EnvelopeIcon className="w-5 h-5 text-gray-700 mr-2" />
        <div className="hidden sm:block">Edit invoice</div>
        <div className="sm:hidden">Invoice</div>
      </Button>
      <Modal open={canOpenModal} onClose={() => setOpenModal(false)} maxWidth="max-w-7xl">
        <ReservationInvoiceWrapper reservation={selectedReservation} order={selectedReservation?.order}>
          {({ orderInvoice, setInvoice }) => {
            return (
              <EditInvoice
                invoice={orderInvoice}
                setSelectedInvoice={setInvoice}
                site={selectedReservation?.site}
                campingStyle={campingStyle}
                onSuccess={(invoice) => setOpenModal(false)}
                isHidingBackButton
                setIsSlideoverOpen={setIsSlideoverOpen}
              />
            )
          }}
        </ReservationInvoiceWrapper>
      </Modal>
    </>
  )
}
